module.exports = "\n<div class=\"app-wrapper\">\n        <app-header></app-header>\n    <router-outlet></router-outlet>\n</div>\n"